/* =====================================================
   Collection "Load More Products" — Figma node 8001:65
   Shows an initial set of products (default 6); one click
   reveals the remaining products on the current page and
   AJAX-fetches/appends any further paginated pages so the
   full collection is displayed.
   ===================================================== */
(function () {
  'use strict';

  async function loadAll(btn) {
    var container = document.getElementById('ProductGridContainer');
    var grid = container && container.querySelector('#product-grid');
    if (!grid) return;

    btn.classList.add('loading');
    btn.disabled = true;

    // 1. Reveal the items already rendered on the current (first) page.
    grid.querySelectorAll('.grid__item[hidden]').forEach(function (item) {
      item.removeAttribute('hidden');
    });

    // 2. Follow pagination, fetching and appending any remaining pages.
    var nextUrl = btn.getAttribute('data-next-url');
    try {
      while (nextUrl) {
        var response = await fetch(nextUrl);
        if (!response.ok) break;

        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');

        doc.querySelectorAll('#product-grid .grid__item').forEach(function (item) {
          item.removeAttribute('hidden');
          grid.appendChild(document.importNode(item, true));
        });

        var nextBtn = doc.querySelector('[data-load-more]');
        nextUrl = nextBtn ? nextBtn.getAttribute('data-next-url') : null;
      }
    } catch (error) {
      console.error('[load-more] failed to load additional products', error);
    }

    // 3. All products are now visible — remove the button.
    var wrapper = btn.closest('.collection-load-more');
    if (wrapper) {
      wrapper.remove();
    } else {
      btn.classList.remove('loading');
      btn.disabled = false;
    }
  }

  // Delegated so it keeps working after facets.js re-renders the grid.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-load-more]');
    if (!btn) return;
    event.preventDefault();
    loadAll(btn);
  });
})();
